import React from 'react';
import styles from './Engagement.module.css';

const Engagement = ({ lang }) => {
  const data = {
    EN: {
      title: "Stay Ahead of the News",
      desc: "Join 50,000+ readers and get our daily morning briefing delivered straight to your inbox.",
      placeholder: "Enter your email address",
      btn: "Subscribe"
    },
    UR: {
      title: "خبروں سے باخبر رہیں",
      desc: "50,000 سے زائد قارئین میں شامل ہوں اور ہماری روزانہ کی مارننگ بریفنگ براہ راست اپنی ای میل پر حاصل کریں۔",
      placeholder: "اپنی ای میل درج کریں",
      btn: "سبسکرائب کریں"
    }
  }[lang];

  return (
    <section className={styles.engSection}>
      <div className={styles.engContainer}>
        <div className={styles.textContent}>
          <h2>{data.title}</h2>
          <p>{data.desc}</p>
        </div>
        
        <div className={styles.formContent}>
          <div className={styles.inputGroup}>
            <input type="email" placeholder={data.placeholder} />
            <button>{data.btn}</button>
          </div>
          <p style={{fontSize: '0.75rem', marginTop: '15px', color: '#999'}}>
            {lang === 'EN' ? "No spam, just top stories." : "کوئی سپیم نہیں، صرف اہم خبریں۔"}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Engagement;